export default function () {
  const $video     = $('#video');
  const $container = $video.parent();

  $video.find('iframe').attr('width', $container.width());
};
